module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-82.b0cf4521.svg";